import { apiClient } from './client';
import { parsedTransactionSchema } from './schemas';
import { z } from 'zod';
import type { ParsedTransactionResponse } from './schemas';

export const statementsApi = {
  preview: (file: File): Promise<ParsedTransactionResponse[]> =>
    apiClient.postRaw(
      '/statements/preview',
      file,
      'application/x-ofx',
      z.array(parsedTransactionSchema),
    ),
};
